import cond from 'lodash/cond';
import constant from 'lodash/constant';
import otherwise from 'lodash/stubTrue';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { Nav4Rollout } from '../../types.tsx';
import { NAV4_ROLLOUT_NONE } from '../../constants.tsx';
import { getNav4RolloutForBetaCohort } from './get-nav4-rollout-for-beta-cohort/index.tsx';
import { getNav4RolloutForDogfooding } from './get-nav4-rollout-for-dogfooding/index.tsx';
import { getNav4RolloutForGaAndBeyond } from './get-nav4-rollout-for-ga-and-beyond/index.tsx';

// eslint-disable-next-line jira/ff/inline-usage
export const getNav4Rollout = cond<Nav4Rollout>([
	[() => !fg('jira_nav4'), constant(NAV4_ROLLOUT_NONE)],
	[() => fg('jira_nav4_dogfooding'), getNav4RolloutForDogfooding],
	[() => fg('jira_nav4_beta_sandboxes'), getNav4RolloutForBetaCohort('sandboxes')],
	[
		() => expVal('jira_nav4_beta_free-customers', 'willShowNav4', false),
		getNav4RolloutForBetaCohort('free-customers'),
	],
	[
		() => expVal('jira_nav4_beta_new-customers', 'willShowNav4', false),
		getNav4RolloutForBetaCohort('new-customers'),
	],
	[
		() => expVal('confluence_jira_nav4_new_customers', 'willShowNav4', false),
		getNav4RolloutForBetaCohort('new-customers-x'),
	],
	// Break up cond for easier testing.
	[otherwise, () => getNav4RolloutForGaAndBeyond()],
]);
